module.exports = __webpack_public_path__ + "img/pc-contact-sw.317300cb.webp";